import { useCallback } from 'react'
import { resetPassword } from '../crud/engage.crud'
import useApiControls from './useApiControls'

const useEngageResetPassword = () => {
  const parseError = useCallback(
    (error) =>
      error?.response?.data?.message || // case request fails in backend
      error?.message, // if error is thrown in a task
    [],
  )

  const controls = useApiControls({ api: resetPassword, parseError }) // loading, error, data, callApi

  return {
    resetPassword: controls.callApi,
    isResetingPassword: controls.loading,
    errorResetingPassword: controls.error,
    successResetingPassword: controls.success,
  }
}

export default useEngageResetPassword
